/**
 * Header
 */

export default function Header() {
    const selectors = {
        'headerMenuWrapper': '#header-menu',
        'menuWrapper': '#menu-header-menu',
        'mobileToggle': '.js-mobile-menu-toggle',
        'headerMenuBottomToggle': '.js-header-bottom-menu-toggle',
        'mobileBreakpoint': 1024,
    };

    this.init = () => {
        this.mobileMenuToggle();
        this.handleMobileMenu();
        this.handleHeaderBottomMenu();
    };

    this.mobileMenuToggle = () => {
        jQuery(selectors.mobileToggle).on('click', function (e) {
            e.preventDefault();
            let forCheckbox = jQuery(this).attr('for');
            if (jQuery(this).hasClass('active')) {
                jQuery('#' + forCheckbox).prop('checked', false);
                jQuery(this).removeClass('active')
            } else {
                jQuery('#' + forCheckbox).prop('checked', true);
                jQuery(this).addClass('active')
            }
        })
    };

    this.handleMobileMenu = () => {
        jQuery(selectors.headerMenuWrapper).on('click', '#menu-header-menu > .menu-item-has-children > a', function (e) {
            if (jQuery(window).width() > selectors.mobileBreakpoint) {
                return;
            }
            let $this = jQuery(this);
            let $parent = $this.parent();
            if ($parent.hasClass('submenu-hidden')) {
                return;
            }
            e.preventDefault();

            if (!$parent.hasClass('menu-shown')) {
                $parent.addClass("menu-shown").find(".dropdown-menu-depth-0").slideDown(400, "swing");
                $parent.siblings().removeClass("menu-shown").find(".dropdown-menu-depth-0").slideUp(400, "swing");
            } else {
                $parent.removeClass("menu-shown").find(".dropdown-menu-depth-0").slideUp(400, "swing");
            }
        })
    }

    this.handleHeaderBottomMenu = () => {
        jQuery(selectors.headerMenuBottomToggle).on('click', function (e) {
            e.preventDefault();
            jQuery("#header-bottom-menu").toggleClass("show-menu");
        })

        jQuery(document).on("click", function (event) {
            var $trigger = jQuery(".navbar-bottom");
            if ($trigger !== event.target && !$trigger.has(event.target).length) {
                jQuery("#header-bottom-menu").removeClass("show-menu");
            }
        });


    }

}
